import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, isRef as _isRef, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '../../assets/logo.png'


const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "hidden-xs-only defaultTitle" }
const _hoisted_4 = { class: "hidden-sm-and-up" }
const _hoisted_5 = { class: "smallTitle" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { id: "module1" }
const _hoisted_8 = { id: "module2" }
const _hoisted_9 = { id: "module4" }
const _hoisted_10 = { id: "module5" }

import { ClickOutside as vClickOutside } from 'element-plus';
import 'element-plus/theme-chalk/display.css'
import module1 from './components/module1.vue'
import module2 from './components/module2.vue'
import module3 from './components/module3.vue'
import module4 from './components/module4.vue'
import module5 from './components/module5.vue'
import { ref } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'home',
  setup(__props) {

let navigationOpenState = ref(false)
const handleSelect = (key: string, keyPath: string[]) => {

}

return (_ctx: any,_cache: any) => {
  const _component_el_anchor_link = _resolveComponent("el-anchor-link")!
  const _component_el_anchor = _resolveComponent("el-anchor")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_affix = _resolveComponent("el-affix")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_affix, { offset: 0 }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _cache[6] || (_cache[6] = _createElementVNode("img", {
              style: {"width":"49px"},
              src: _imports_0
            }, null, -1)),
            _createVNode(_component_el_anchor, {
              offset: 28,
              direction: "horizontal"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_anchor_link, { href: "#module1" }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode(" 首页 ")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_anchor_link, { href: "#module2" }, {
                  default: _withCtx(() => _cache[3] || (_cache[3] = [
                    _createTextVNode(" 产品 ")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_anchor_link, { href: "#module4" }, {
                  default: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createTextVNode(" 客户案例 ")
                  ])),
                  _: 1
                }),
                _createVNode(_component_el_anchor_link, { href: "#module5" }, {
                  default: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createTextVNode(" 关于我们 ")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_anchor, {
              offset: 28,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_isRef(navigationOpenState) //@ts-ignore
 ? navigationOpenState.value = false : navigationOpenState = false))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _cache[7] || (_cache[7] = _createElementVNode("img", {
                    style: {"width":"49px"},
                    src: _imports_0
                  }, null, -1)),
                  _createVNode(_component_el_icon, {
                    size: "30",
                    color: "#000",
                    class: "menuIcon",
                    style: _normalizeStyle({ transform: _unref(navigationOpenState) ? 'rotate(-90deg)' : 'rotate(270deg)'}),
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_isRef(navigationOpenState) //@ts-ignore
 ? navigationOpenState.value = !_unref(navigationOpenState) : navigationOpenState = !_unref(navigationOpenState)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Menu)
                    ]),
                    _: 1
                  }, 8, ["style"])
                ]),
                (_unref(navigationOpenState))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_el_anchor_link, { href: "#module1" }, {
                        default: _withCtx(() => _cache[8] || (_cache[8] = [
                          _createTextVNode(" 首页 ")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_anchor_link, { href: "#module2" }, {
                        default: _withCtx(() => _cache[9] || (_cache[9] = [
                          _createTextVNode(" 产品 ")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_anchor_link, { href: "#module4" }, {
                        default: _withCtx(() => _cache[10] || (_cache[10] = [
                          _createTextVNode(" 客户案例 ")
                        ])),
                        _: 1
                      }),
                      _createVNode(_component_el_anchor_link, { href: "#module5" }, {
                        default: _withCtx(() => _cache[11] || (_cache[11] = [
                          _createTextVNode(" 关于我们 ")
                        ])),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode(module1)
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(module2)
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(module4)
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(module5)
    ]),
    _cache[12] || (_cache[12] = _createElementVNode("a", {
      class: "beian",
      href: "https://beian.miit.gov.cn/#/Integrated/index",
      target: "_blank"
    }, "由智慧家园提供技术支持 备案号：陕ICP备2022001360号", -1))
  ]))
}
}

})